import React, { ComponentType, PureComponent } from 'react';
import { GooglePayConfigurationContext } from '../services/GooglePayConfigurationContext';

const withGooglePayConfigurationContext = <P extends object>(Component: ComponentType<P>) => {
  class WithGooglePayConfigurationContext extends PureComponent<P> {
    render() {
      return (
        <GooglePayConfigurationContext.Consumer>
          {value => <Component {...this.props} {...value} />}
        </GooglePayConfigurationContext.Consumer>
      );
    }
  }

  return WithGooglePayConfigurationContext;
};

export default withGooglePayConfigurationContext;
